export default __webpack_public_path__ + "static/media/Book2.29f59903.jpeg";